<script setup lang="ts">
import bannerImg from '@/assets/img/banner.svg';
import { AppTypography } from '@/components/base';

const props = withDefaults(
  defineProps<{
    title: string;
  }>(),
  {}
);
</script>
<template>
  <div
    class="banner"
    :style="{
      backgroundImage: `url(${bannerImg})`,
    }"
  >
    <div class="d-flex align-start">
      <AppTypography type="title-1" class="mr-2">{{ title }}</AppTypography>
      <AppTypography type="title-1">👋</AppTypography>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.banner {
  width: 100%;
  background-size: cover;
  border-radius: 16px;
  padding: 75px 20px 20px 20px;
}
</style>
